// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal1_modal__4RPxL"};